"use strict";

exports.__esModule = true;
exports.IconsBar = void 0;
var _uiSwitch = require("../../Theme/UiDesign/uiSwitch");
var _IconsBar = require("./IconsBar.legacy");
var _IconsBar2 = require("./IconsBar.modern");
// Flag-gated UI: `IconsBar.legacy` is the component as it is on master,
// `IconsBar.modern` the ui-charts-update rewrite. The nearest UiDesignProvider
// (ENABLE_MODERN_UI + the screen's flag) decides which one renders.
var IconsBar = exports.IconsBar = (0, _uiSwitch.uiSwitch)(_IconsBar.IconsBar, _IconsBar2.IconsBar, "IconsBar");